import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { SampleIepGoal } from 'src/app/models/goal/goal.model';
import { ButtonModule } from 'src/app/shared/form/button/button.module';

@Component({
  selector: 'app-sample-iep-goals',
  templateUrl: './sample-iep-goals.component.html',
  styleUrls: ['./sample-iep-goals.component.scss'],
  imports: [CommonModule, FormsModule, DragDropModule, ButtonModule],
})
export class SampleIepGoalsComponent {
  @Input() goals: SampleIepGoal[] = [{ title: '', description: '' }];
  @Output() goalsChange = new EventEmitter<SampleIepGoal[]>();

  iepPasteOpen = false;

  add() {
    this.goals = [...this.goals, { title: '', description: '' }];
    this.goalsChange.emit(this.goals);
  }

  remove(index: number) {
    this.goals = this.goals.filter((_, i) => i !== index);
    this.goalsChange.emit(this.goals);
  }

  clear() {
    this.goals = [{ title: '', description: '' }];
    this.goalsChange.emit(this.goals);
  }

  onBulkPaste(text: string) {
    const lines = text.split('\n').map(l => l.trim()).filter(l => l.length > 0);
    const parsed: SampleIepGoal[] = [];
    for (let i = 0; i < lines.length; i += 2) {
      parsed.push({ title: lines[i], description: lines[i + 1] ?? '' });
    }
    if (parsed.length > 0) {
      this.goals = parsed;
      this.goalsChange.emit(this.goals);
    }
  }

  onFieldChange() {
    this.goalsChange.emit(this.goals);
  }

  onDrop(event: CdkDragDrop<SampleIepGoal[]>) {
    moveItemInArray(this.goals, event.previousIndex, event.currentIndex);
    this.goalsChange.emit(this.goals);
  }
}
